// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GKhmx","box":"styles_box__ETiC5","title":"styles_title__5DacS","icon":"styles_icon__tsvEi","icone":"styles_icone__0R3ha"};